const API = "/api";

function getToken() {
  return localStorage.getItem("token");
}

// keep for JSON endpoints (unchanged behavior)
async function apiFetch(path, opts = {}) {
  const headers = { "Content-Type": "application/json", ...(opts.headers || {}) };

  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API}${path}`, { ...opts, headers });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data?.error || `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

// NEW: raw fetch that still attaches auth, but does not force JSON headers
async function apiFetchRaw(path, opts = {}) {
  const headers = { ...(opts.headers || {}) };

  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API}${path}`, { ...opts, headers });
  return res;
}

// NEW: blob download helper
async function apiFetchBlob(path, opts = {}) {
  const res = await apiFetchRaw(path, opts);

  if (!res.ok) {
    // try to read JSON error if backend sent it
    let msg = `HTTP ${res.status}`;
    try {
      const j = await res.json();
      msg = j?.error || j?.message || msg;
    } catch (_) {}
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }

  const blob = await res.blob();
  const contentDisposition = res.headers.get("content-disposition") || "";
  return { blob, contentDisposition };
}


export const api = {
  signup: (username, password) =>
    apiFetch("/auth/signup", { method: "POST", body: JSON.stringify({ username, password }) }),

  login: (username, password) =>
    apiFetch("/auth/login", { method: "POST", body: JSON.stringify({ username, password }) }),

  health: () => apiFetch("/health"),

  runCalc: (payload) =>
    apiFetch("/calc/run", { method: "POST", body: JSON.stringify(payload) }),

  requestContact: (whatsapp) =>
    apiFetch("/calc/request-contact", { method: "POST", body: JSON.stringify({ whatsapp }) }),

  adminContactHandled: (id) =>
    apiFetch(`/admin/users/${id}/contact-handled`, { method: "POST" }),

  myLogs: () => apiFetch("/calc/my-logs"),

  // admin
  adminUsers: () => apiFetch("/admin/users"),
  adminUser: (id) => apiFetch(`/admin/users/${id}`),
  adminPatchUser: (id, patch) =>
    apiFetch(`/admin/users/${id}`, { method: "PATCH", body: JSON.stringify(patch) }),
  adminCreateUser: (payload) =>
    apiFetch(`/admin/users`, { method: "POST", body: JSON.stringify(payload) }),
  adminSetPassword: (id, password) =>
    apiFetch(`/admin/users/${id}/password`, { method: "POST", body: JSON.stringify({ password }) }),
  adminDeleteUser: (id) => apiFetch(`/admin/users/${id}`, { method: "DELETE" }),

  adminGetSettings: () => apiFetch("/admin/settings"),
  adminPutSettings: (settings) =>
    apiFetch("/admin/settings", { method: "PUT", body: JSON.stringify(settings) }),

    // admin-calc
  adminCalcGetSettings: () => apiFetch("/admin-calc/settings"),

  adminCalcPutSettings: (settings) =>
    apiFetch("/admin-calc/settings", { method: "PUT", body: JSON.stringify(settings) }),

  adminCalcRun: ({ customerName, input }) =>
    apiFetch("/admin-calc/run", { method: "POST", body: JSON.stringify({ customerName, input }) }),

adminCalcEntries: ({ search = "", sort = "desc", limit = 20, cap = 10, cursor = "" } = {}) => {
  const qs = new URLSearchParams();
  if (search) qs.set("search", search);
  if (sort) qs.set("sort", sort);
  if (limit) qs.set("limit", String(limit));
  if (cap) qs.set("cap", String(cap));
  if (cursor) qs.set("cursor", cursor);
  const q = qs.toString();
  return apiFetch(`/admin-calc/entries${q ? `?${q}` : ""}`);
},

  adminCalcDeleteEntry: (id) =>
    apiFetch(`/admin-calc/entries/${id}`, { method: "DELETE" }),

  // push
  pushSubscribe: (sub) =>
    apiFetch("/push/subscribe", { method: "POST", body: JSON.stringify(sub) }),
  pushUnsubscribe: (endpoint) =>
    apiFetch("/push/unsubscribe", { method: "POST", body: JSON.stringify({ endpoint }) }),
 pushUnsubscribeAll: () =>
    apiFetch("/push/unsubscribe-all", { method: "POST" }),
 pushTest: () =>
  apiFetch("/push/test", { method: "POST" }),


  adminCalcDownloadPdf: (id) =>
    apiFetchBlob(`/reports/admin/calc/entries/${id}/report.pdf`, { method: "GET" }),

    // percent-calc
  percentCalcGetSettings: () => apiFetch("/percent-calc/settings"),

  percentCalcPutSettings: (settings) =>
    apiFetch("/percent-calc/settings", { method: "PUT", body: JSON.stringify(settings) }),

  percentCalcRun: (input, label = "") =>
    apiFetch("/percent-calc/run", { method: "POST", body: JSON.stringify({ input, label }) }),

  percentCalcEntries: ({ search = "", sort = "desc", limit = 20, cap = 10, cursor = "" } = {}) => {
    const qs = new URLSearchParams();
    if (search) qs.set("search", search);
    if (sort) qs.set("sort", sort);
    if (limit) qs.set("limit", String(limit));
    if (cap) qs.set("cap", String(cap));
    if (cursor) qs.set("cursor", cursor);
    const q = qs.toString();
    return apiFetch(`/percent-calc/entries${q ? `?${q}` : ""}`);
  },

  percentCalcPatchEntry: (id, patch) =>
    apiFetch(`/percent-calc/entries/${id}`, { method: "PATCH", body: JSON.stringify(patch) }),

  percentCalcDeleteEntry: (id) =>
    apiFetch(`/percent-calc/entries/${id}`, { method: "DELETE" }),

// basf-calc
basfCalcGetSettings: () => apiFetch("/basf-calc/settings"),

basfCalcPutSettings: (settings) =>
  apiFetch("/basf-calc/settings", { method: "PUT", body: JSON.stringify(settings) }),

basfCalcRun: ({ customerName, input }) =>
  apiFetch("/basf-calc/run", { method: "POST", body: JSON.stringify({ customerName, input }) }),

basfCalcEntries: ({ search = "", sort = "desc", limit = 20, cap = 10, cursor = "" } = {}) => {
  const qs = new URLSearchParams();
  if (search) qs.set("search", search);
  if (sort) qs.set("sort", sort);
  if (limit) qs.set("limit", String(limit));
  if (cap) qs.set("cap", String(cap));
  if (cursor) qs.set("cursor", cursor);
  const q = qs.toString();
  return apiFetch(`/basf-calc/entries${q ? `?${q}` : ""}`);
},

basfCalcDeleteEntry: (id) =>
  apiFetch(`/basf-calc/entries/${id}`, { method: "DELETE" }),

// gdbu-calc
gdbuCalcGetSettings: () => apiFetch("/gdbu-calc/settings"),

gdbuCalcPutSettings: (settings) =>
  apiFetch("/gdbu-calc/settings", { method: "PUT", body: JSON.stringify(settings) }),

gdbuCalcRun: ({ customerName, input }) =>
  apiFetch("/gdbu-calc/run", { method: "POST", body: JSON.stringify({ customerName, input }) }),

gdbuCalcEntries: ({ search = "", sort = "desc", limit = 20, cap = 10, cursor = "" } = {}) => {
  const qs = new URLSearchParams();
  if (search) qs.set("search", search);
  if (sort) qs.set("sort", sort);
  if (limit) qs.set("limit", String(limit));
  if (cap) qs.set("cap", String(cap));
  if (cursor) qs.set("cursor", cursor);
  const q = qs.toString();
  return apiFetch(`/gdbu-calc/entries${q ? `?${q}` : ""}`);
},

gdbuCalcDeleteEntry: (id) =>
  apiFetch(`/gdbu-calc/entries/${id}`, { method: "DELETE" }),

gdbuCalcDownloadPdf: (id) =>
  apiFetchBlob(`/reports/gdbu/calc/entries/${id}/report.pdf`, { method: "GET" }),

// referral QR
adminReferralCreate: ({ employeeName, code }) =>
  apiFetch("/referral/create", {
    method: "POST",
    body: JSON.stringify({ employeeName, code }),
  }),

adminReferralList: () =>
  apiFetch("/referral/list"),

adminReferralQr: (code) =>
  apiFetch(`/referral/qr/${encodeURIComponent(code)}`),

adminReferralDisable: (code) =>
  apiFetch(`/referral/disable/${encodeURIComponent(code)}`, {
    method: "PATCH",
  }),
};
